module Meevo.Plugins.Egifts {
    'use strict';

    import DiscountTypeEnum = Meevo.Model.DiscountTypeEnum;
    import DiscountEntityTypeEnum = Meevo.Model.DiscountEntityTypeEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import BOGOBasedOnTypeEnum = Meevo.Model.BOGOBasedOnTypeEnum;
    import SortDirection = Meevo.Model.SortDirection;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import DiscountRedeemableLimitPerTypeEnum = Meevo.Model.DiscountRedeemableLimitPerTypeEnum;
    import IMaintenanceFormCustomButton = Meevo.Components.Controls.IMaintenanceFormCustomButton;
    import GiftCardType = Meevo.Model.GiftCardType;

    

    export class PromotionsSection extends EgiftsBaseSection {
        public model: EgiftPromotionsSection.IEgiftDiscount = this.getDefaultModel();
        public promotionTypes: Array<EgiftPromotionsSection.IPromotiontType>;
        public discountTypes: Array<EgiftPromotionsSection.IPromotiontType> = this.discountTypesData;
        public bogoBasedOnTypes: Array<EgiftPromotionsSection.IBogoBasedOnTypes> = this.bogoBasedOnTypesData;
        public locationPromotionFilter: Array<EgiftPromotionsSection.ILocationPromotionFilter> = this.locationPromotionFilterData;
        public validPromoGiftCards: Array<GiftCardType> = [];

        public selectedDiscount: DiscountTypeEnum;
        public promotionAmount: number = 0;
        public promotionDescription: string;
        public limitNumberOfTimesUse: boolean = false;
        public limitCount: number;
        public minPurchaseCount: number = 1;
        public isPromotionSilent: boolean = false;
        public arrayResults: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
        public request: any = this.defaultRequestModel;
        public isUndeleteMode = false;
        public showSelectedPromotion: boolean = false;
        public isCreatingPromo: boolean = false;
        public isShowEditButton: boolean = true;

        protected identityService: Meevo.Components.Common.IIdentityService;
        disableCrud: boolean = true;

        private buttonsSet: Array<IMaintenanceFormCustomButton> = this.buttonsSetData;

        constructor(
            params: ISectionParamsEgifts,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $translate: angular.translate.ITranslateService,
            protected $scope: angular.IScope
        ) {
            super(params);
        }

        activate() {
            this.rollbackChanges();
            this.reloadData();
        }

        selected() {
            super.selected();
            this.promotionTypes = this.promotionTypesData;
        }

        createPromo() {
            this.isCreatingPromo = true;
            this.setState(MaintenanceFormState.Adding)
        }

        setState(mode: MaintenanceFormState): void {
            this.disableCrud = false;
            this.showSelectedPromotion = true;
            this.context.setMode(mode);
        }

        closeCreation() {
            this.disableCrud = true;
            this.context.setMode(MaintenanceFormState.Readonly);
            this.rollbackChanges();
        }

        reloadData(): void {
            this.disableCrud = true;
            this.showSelectedPromotion = false;
            this.getData(true);
        }

        preSave() {
            // Todo: Remove in the next phase !
            if (!angular.isDefined(this.model.isMembershipClientDiscount)) this.model.isMembershipClientDiscount = false;

            if (this.model.isRedeemableLimitApplicable && !angular.isDefined(this.model.discountRedeemableLimitPerTypeEnum)) {
                this.model.discountRedeemableLimitPerTypeEnum = DiscountRedeemableLimitPerTypeEnum.Transaction;
            }

            if (this.model.discountTypeEnum != DiscountTypeEnum.PromotionalGiftCard)
                this.model.promoGiftCardTypeId = null; //CK_Discount_T_DiscountTypeEnum_PromoGiftCardTypeId constraint (if changing promotype when editing)

            if (this.model.isBuyGet) {

                if (this.model.discountTypeEnum === DiscountTypeEnum.PromotionalGiftCard) {
                    this.model.discountAmount = 1
                    this.model.eGift_CombineFreeCards = true;
                }
                else
                // If Free is choosen, discount type is Percent off with 100% discount
                if (this.model.discountTypeEnumGet === DiscountTypeEnum.SpecialPrice) {                    
                    this.model.discountTypeEnum = DiscountTypeEnum.PercentOff;
                    this.model.discountAmount = 1;
                    // TODO: Remove in the the nex phase when we shouldn't combine free card
                    this.model.eGift_CombineFreeCards = true;
                } else {
                    this.model.discountTypeEnum = this.model.discountTypeEnumGet;
                }

                if (this.model.bogoBasedOnTypeEnum == BOGOBasedOnTypeEnum.Amount) {
                    this.model.isAllowRedeemBuyGet = false;
                }
            }
        }

        customSave(): ng.IPromise<any> {
            let saveFunction;

            if (this.mode === MaintenanceFormState.Adding) saveFunction = this.egiftsService.addNewPromo(this.model);
            else if (this.mode === MaintenanceFormState.Editing || this.isUndeleteMode) saveFunction = this.egiftsService.editPromo(this.model);

            return saveFunction;
        }

        addNewPromo() {
            this.loadingInProgress = true;
            this.preSave();
            this.busyService.start();

            return this.customSave()
                .then(_ => this.loggingService.trace(`Updates saved.`))
                .finally(() => {
                    this.context.setMode(MaintenanceFormState.Readonly);
                    this.activate();
                    this.loadingInProgress = false;
                    this.showSelectedPromotion = false;
                    this.busyService.stop();
                });
        }

        sort(sortBy: string, sortDirection: SortDirection) {
            // Sort direction will be reseted to ascending, when click on other header
            // Otherwise, sort direction wil be changed to the opposite
            console.log(sortBy)
            this.request.sortDirection = this.request.sortBy === sortBy ? +!this.request.sortDirection : SortDirection.Ascending;
            this.request.sortBy = sortBy;

            this.getData(true);
        }

        getData(isNotResetSearchOption: boolean = false) {
            // All search params should be remove when this tab is chosen one more time
            if (!isNotResetSearchOption) {
                this.request = this.defaultRequestModel;
            }

            let request: any = angular.copy(this.request),
                url: string = 'eGift/discount';
            request.criteria.isBuyGet = request.criteria.discountType ? request.criteria.discountType === DiscountTypeEnum.BuyGet : null;
            if (request.criteria.discountType === DiscountTypeEnum.BuyGet) request.criteria.discountType = null;

            this.busyService.start();
            // if count of elements > 0, callback works
            this.arrayResults = this.getResults(url);
            return this.arrayResults.initSearch(request)
                .finally(() => this.busyService.stop());
        }



        preEditPromo(item: any, location : COBusinessType):void {
            if (location == COBusinessType.Location && !this.context.isCommonLocation) {
                return
            }

            this.editPromo(item, location);
        }

        editPromo(item: any, location : COBusinessType): void {
            this.busyService.start();
            this.egiftsService.getPromo(item.id).then((promotion: any) => {
                this.showSelectedPromotion = true;
                let mode;
                if (location == COBusinessType.Location) {
                    this.isShowEditButton = item.homeLocationId == this.identityService.locationId;
                    mode = MaintenanceFormState.Readonly;
                    this.model = this.preparedEgiftDiscount(promotion);
                    this.disableCrud = true;
                } else {
                    mode = MaintenanceFormState.Editing;
                    this.model = this.preparedEgiftDiscount(promotion);

                    if (promotion.objectState === ObjectStateEnum.Deleted) {
                        mode = MaintenanceFormState.Readonly;
                        this.isUndeleteMode = true;
                    }
                }

                this.setState(mode);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        deletePromo(item): void {
            this.modalService.confirm('MESSAGE_DELETE_CONFIRMATION', Components.Modal.ModalTranslationModes.Translate)
                .then(_ => {
                    this.busyService.start();
                    return this.egiftsService.deletePromo(item.id, {
                        objectState: ObjectStateEnum.Deleted
                    });
                }).then(_ => {
                    return this.getData(true);
                }).finally(() => this.busyService.stop());
        }

        rollbackChanges() {
            this.model = this.getDefaultModel();
        }

        onDiscountTypeChanged(): void {
            if (this.model.discountTypeEnum === DiscountTypeEnum.BuyGet || this.model.discountTypeEnum === DiscountTypeEnum.PromotionalGiftCard) {
                this.model.isBuyGet = true;
                if (this.model.buy_Quantity <= 0) this.model.buy_Quantity = 1;
                if (this.model.get_Quantity <= 0) this.model.get_Quantity = 1;
            } else {
                this.model.isBuyGet = false;
                this.model.buy_Quantity = 0;
                this.model.get_Quantity = 0;
            }

            this.onDiscountChanged()
            if (this.model.discountTypeEnum === DiscountTypeEnum.PromotionalGiftCard)
                this.buildValidPromoGiftCards();
            else
                this.validPromoGiftCards = [];
        }

        buildValidPromoGiftCards(): void {
                this.egiftsService.getActivePromoGiftCards().then(data => {
                    this.validPromoGiftCards = data;
                })
        }

        onDiscountChanged() {
            this.model.buy_Amount = 1;
            this.model.get_Amount = 1;
            this.model.buy_AmountMin = 0;
            this.model.buy_AmountMax = 0;
            this.model.get_AmountMax = 0;
            this.model.get_AmountMin = 0;
            this.model.discountAmount = 0;
        }

        showFilter() {
            let modalScope = this.$scope.$new(true);
            modalScope['context'] = this;
            
            let options: Meevo.Components.Modal.IModalOptions = {
                scope: modalScope,
                templateUrl: 'app/plugins/egifts/sectionViews/modal/promotion.advFilters.html',
            }
            this.modalService.showCustom(options);
        }

        onFilterSearch() {
            this.request.criteria.includeActive = this.request.criteria.includeDeleted ? false : true;

            this.reloadData();
            this.modalService.hide();
        }

        postCancel() {
            this.isCreatingPromo = false;
            this.showSelectedPromotion = false;
        }

        inactivatePromotion() {
            const objectState = this.model.objectState == ObjectStateEnum.Active ? ObjectStateEnum.Inactive : ObjectStateEnum.Active;

            this.egiftsService.inactivatePromotion((this.model as any).id, objectState).then(() => {
                this.context.cancel()
            })
        }

        private undeletePromotion() {
            this.model.objectState = ObjectStateEnum.Active;
            this.addNewPromo();
            this.isUndeleteMode = false;   
        }

        private getPromotionName(promotion: EgiftPromotionsSection.IDiscount): string {
            if (!promotion) return '';

            let promotionType = promotion.discountTypeEnum == DiscountTypeEnum.PromotionalGiftCard ? DiscountTypeEnum.PromotionalGiftCard :  promotion.isBuyGet ?DiscountTypeEnum.BuyGet: promotion.discountTypeEnum;
            let promotionTypeElement = _.find(this.promotionTypes, promo => promo.value === promotionType);

            return promotionTypeElement.label;
        }

        private preparedEgiftDiscount(promotion: EgiftPromotionsSection.IEgiftDiscount): EgiftPromotionsSection.IEgiftDiscount {
            if (promotion.isBuyGet) {
                if (promotion.promoGiftCardTypeId && new Guid(promotion.promoGiftCardTypeId) != Guid.empty) {
                    promotion.discountTypeEnum = DiscountTypeEnum.PromotionalGiftCard;
                    promotion.discountTypeEnumGet = DiscountTypeEnum.SpecialPrice;
                    this.buildValidPromoGiftCards();
                    return promotion;
                }

                promotion.discountTypeEnumGet = promotion.discountTypeEnum == DiscountTypeEnum.PercentOff && promotion.discountAmount === 1 ? DiscountTypeEnum.SpecialPrice : promotion.discountTypeEnum;
                promotion.discountTypeEnum = DiscountTypeEnum.BuyGet
            }

            return promotion;
        }

        private translate(key: string, parameters?: any): string {
            return this.$translate.instant(key, parameters);
        }

        get isCreatingPromotion() {
            return this.mode === MaintenanceFormState.Adding;
        }

        get promotionTypeEnum(): any {
            return DiscountTypeEnum;
        }

        get bogoBasedOnTypeEnum(): any {
            return BOGOBasedOnTypeEnum;
        }

        get sortDirection(): any {
            return SortDirection;
        }

        get applyPromotionCode() {
            return this.translate('LABEL_USERS_APPLY_PROMOTION_CODE', { User: this.translate('LABEL_USER') });
        }
       

        get createPromotionSecurityKey(): string {
            return Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_PROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
        }

        get editPromotionSecurityKey(): string {
            return Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_PROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
        }

        get deletePromotionSecurityKey(): string {
            return Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_PROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
        }

        get maintenanceFormState() {
            return MaintenanceFormState;
        }

        get objectStateEnum() {
            return ObjectStateEnum;
        }

        get locationOrCoEnum() {
            return COBusinessType;
        }

        get isUnDeleteState(): boolean {
            return this.model.objectState === ObjectStateEnum.Deleted
        }

        get isInActiveState(): boolean {
            return this.model.objectState === ObjectStateEnum.Inactive
        }

        //// Promotions Data ////

        get defaultRequestModel() {
            return {
                criteria: {
                    businessType: null,
                    coBusinessTypeId: null,
                    coFilterByLocationId: null,
                    coSearchResultFilter: 0,
                    coSearchType: this.context.isCommonLocation ? null : 0,
                    discountType: null,
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false,
                    location: null,
                    maintenanceMode: true,
                    isEGift: true,
                    isBuyGet: null,
                    isCoOwned: null
                },
                itemsPerPage: 25,
                sortBy: 'displayName',
                sortDirection: SortDirection.Ascending,
            };
        }

        get isNewEgiftEnabled(): boolean {
            let mainSection = _.first(this.context.sections);
            return mainSection.model && mainSection.model.settings.enableNewEgiftExperience;
        }

        get promotionTypesData(): Array<EgiftPromotionsSection.IPromotiontType> {
            let ret = [
                { value: DiscountTypeEnum.AmountOff, label: 'LABEL_SPECIFIC_AMOUNT_OFF' },
                { value: DiscountTypeEnum.PercentOff, label: 'LABEL_PERCENT_OFF' },
                { value: DiscountTypeEnum.BuyGet, label: 'LABEL_BUY_ONE_GET_ONE' },
            ];
            if (this.isNewEgiftEnabled) {
                ret.push({ value: DiscountTypeEnum.PromotionalGiftCard, label: 'LABEL_PROMOTIONAL_GIFT_CARD' });
            }

            return ret;
        }

        get discountTypesData(): Array<EgiftPromotionsSection.IPromotiontType> {
           return [
                { value: DiscountTypeEnum.AmountOff, label: 'LABEL_AMOUNT_OFF' },
                { value: DiscountTypeEnum.PercentOff, label: 'LABEL_PERCENT_OFF' },
                { value: DiscountTypeEnum.SpecialPrice, label: 'LABEL_FREE' }
            ];
        }

        get bogoBasedOnTypesData(): Array<EgiftPromotionsSection.IBogoBasedOnTypes> {
           return [
                { value: BOGOBasedOnTypeEnum.Quantity, label: 'LABEL_QUANTITY' },
                { value: BOGOBasedOnTypeEnum.Amount, label: 'LABEL_AMOUNT' },
            ];
        }

        get locationPromotionFilterData(): Array<EgiftPromotionsSection.ILocationPromotionFilter> {
           return [
                {
                    value: COBusinessType.All,
                    label: 'LABEL_ALL_PROMOTIONS'
                }, {
                    value: COBusinessType.CentralOffice,
                    label: 'LABEL_CENTRAL_OFFICE_PROMOTIONS'
                }, {
                    value: COBusinessType.Location,
                    label: 'LABEL_LOCATION_PROMOTIONS'
                },
            ];
        }

        get buttonsSetData(): Array<IMaintenanceFormCustomButton> {
            return [
                {
                    text: 'LABEL_INACTIVE',
                    classNames: 'meevo-button',
                    clickHandler: () => this.inactivatePromotion(),
                    disableRules: () => false,
                    visibilityRules: () => !this.isInActiveState && this.showSelectedPromotion && !this.isCreatingPromo && !this.isUnDeleteState,
                    securityRules: Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_PROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'left'
                },
                {
                    text: 'LABEL_ACTIVATE',
                    classNames: 'meevo-button',
                    clickHandler: () => this.inactivatePromotion(),
                    disableRules: () => false,
                    visibilityRules: () => this.isInActiveState && this.showSelectedPromotion && !this.isCreatingPromo && !this.isUnDeleteState,
                    securityRules: Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_PROMOTIONS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                    position: 'left'
                },
                {
                    text: 'LABEL_UNDELETE',
                    classNames: 'meevo-bottom-button-undelete meevo-button',
                    clickHandler: () => this.undeletePromotion(),
                    disableRules: () => false,
                    visibilityRules: () => this.isUnDeleteState,
                    securityRules: null,
                    position: 'left'
                },
                {
                    text: 'LABEL_CANCEL',
                    classNames: 'meevo-button',
                    clickHandler: () => {
                        this.context.setMode(MaintenanceFormState.Readonly);
                        this.activate();
                        this.isUndeleteMode = false;
                    },
                    disableRules: () => false,
                    visibilityRules: () => this.isUnDeleteState || ((this.showSelectedPromotion && !this.context.isEditing) && !this.isCreatingPromo),
                    securityRules: null,
                    position: 'right'
                }
            ];
        }

        private getDefaultModel(): EgiftPromotionsSection.IEgiftDiscount {
            return {
                buy_Amount: 1,
                get_Amount: 1,
                buy_AmountMin: 0,
                buy_AmountMax: 0,
                get_AmountMax: 0,
                get_AmountMin: 0,
                discountAmount: 0,
                isBuyGet: null,
                isEGift: true,
                discountEntityTypeEnum: DiscountEntityTypeEnum.GiftCard,
                objectState: Meevo.Model.ObjectStateEnum.Active,
                discountEntityGranularityTypeEnum: Meevo.Model.DiscountEntityGranularityTypeEnum.All,
                locationId: this.identityService.locationId,
                availableToLocations: true,
                locationOverride: {
                    duplicationOption: 0,
                    locations: []
                },
                homeLocationId: this.identityService.locationId,
                promoGiftCardTypeId: null
            };
        }

    }
}
